<div class="action-container">
  <!-- NOT NEEDED FOR PHASE 1 -->
    <!-- <div class="action-btn-class">
        <app-button [buttonText]="'Publish'" [backgroundColor]="'#00AA40'" [Color]="'#ffffff'"
            [flexDirection]="'row-reverse'" iconUrl="assets/icons/arrow_downward.svg"
            (onButtonClick)="publishAction()">
        </app-button>

        <app-button [buttonText]="'Save as Draft'" [backgroundColor]="'#534AD8'" [Color]="'#ffffff'"
            (onButtonClick)="saveAsDraftAction()">
        </app-button>
    </div>
    <div class="segment">

    </div> -->
</div>
